import React, { useEffect, useState } from "react";
import "./searchSection.scss";
const SearchSection = (props) => {
  const [keyWord, setkeyWord] = useState("");
  const [selectedStatus, setselectedStatus] = useState("");

  console.log("Available Status", props.availableDemoStatus);

  return (
    <div className="searchSection">
      <div className="row">
        <div className="col-md-12">
          <h5>Filter leads:</h5>
        </div>
        <div className="col-md-4 mt-2">
          <label class="sr-only" for="inlineFormInputGroupUsername">
            Username
          </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text">
                <i className="fas fa-search"></i>
              </div>
            </div>
            <input
              type="text"
              className="form-control"
              id="inlineFormInputGroupUsername"
              placeholder="Search by Name or Number..."
              value={keyWord}
              onChange={(e) => setkeyWord(e.target.value)}
            />
          </div>
        </div>
        <div className="form-group col-md-4 mt-2">
          <select
            id="inputState"
            className="form-control"
            onChange={(e) => setselectedStatus(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="1">Signup</option>
            <option value="2">Initial Call</option>
            <option value="3">Demo Scheduled</option>
            <option value="4">Demo Conducted</option>
            <option value="spam">Spam</option>
            <option value="not_interested">Not Interested</option>
            <option value="no_response">No Response</option>
          </select>
        </div>
        <div className="col-md-4 text-center mt-2">
          <button
            className="btn btn-light"
            onClick={() => props.applyFilter(keyWord, selectedStatus)}
          >
            Search
          </button>
          {props.filterLoading ? (
            <div
              className="spinner-border ml-5 spinner-border-sm"
              role="status"
            >
              <span className="sr-only mt-2">Loading...</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
